import type { ProfileTheme } from '@shared';
import type { IconName } from './Icon';

/**
 * The mark a creator's money wears.
 *
 * The counterpart of `THEME_EMBLEMS` for the wheel hub, and here for the same
 * reason: a realm that calls its currency Moonpetals and still stamps a stack of
 * coins beside every balance has been renamed rather than dressed. The name and
 * the mark have to agree, or the label reads as a skin over someone else's game.
 *
 * Themed on purpose, unlike a wheel's slice colours: this is not the creator's
 * data, it is the app's own furniture — the same call that lets a theme repaint
 * the rim and the pegs but never the prizes.
 *
 * Deliberately **not** a free choice. Every icon here has to survive the 14px it
 * gets inside a balance pill and stay legible against the brand ramp of its own
 * theme, which a picker could not guarantee. A fourth theme is one line, exactly
 * like `PROFILE_THEMES` and `THEME_PALETTES`.
 */
export const CREDIT_ICONS: Record<ProfileTheme, IconName> = {
  spoyl: 'coins',
  elf: 'petal',
  vampire: 'droplet',
};

export function creditIconFor(theme: ProfileTheme): IconName {
  return CREDIT_ICONS[theme] ?? CREDIT_ICONS.spoyl;
}
